<div fxLayout="column" fxLayoutGap="15px" class="confirm-dialog" [formGroup]="mailForm">
  <h3>{{text}}</h3>
  <app-dict-users
    fxFlex="50" label="Użytkownik"
    [multiple]="false"
    (selectedUser)="selectedUser($event)"
  >
  </app-dict-users>
  <div fxLayout="row" fxLayoutGap="15px">
    <mat-form-field fxFlex="70">
      <mat-label>Email</mat-label>
      <input matInput placeholder="adres@test.pl" [formControl]="emailControl" [required]="true">
      <mat-error *ngIf="mailForm.get('email').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error *ngIf="mailForm.get('email').hasError('invalidEmailAddress')">Podaj prawidłowy adres email</mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="25">
      <mat-label>Kwota rozliczenia</mat-label>
      <input matInput formControlName="totalCommission" [required]="true" >
      <mat-error *ngIf="mailForm.get('totalCommission').hasError('required')">To pole jest wymagane</mat-error>
    </mat-form-field>
    <mat-form-field fxFlex="25">
      <mat-label>Saldo</mat-label>
      <input matInput formControlName="toPayNet" [required]="true" >
      <mat-error *ngIf="mailForm.get('toPayNet').hasError('required')">To pole jest wymagane</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button (click)="confirm()" [class.spinner]="processingRequest" [disabled]="processingRequest" mat-raised-button color="warn"><span> Tak</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
    </div>
  </div>
</div>
